<template>
  <div class="message-table-comp">
    <el-table
            class="message-table-en"
            :data="tableData"
            empty-text="No Data"
            style="width: 100%">
      <el-table-column
              label="Title"
              min-width="395" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-html="scope.row.title"></div>
        </template>
      </el-table-column>
      <el-table-column width="210">
        <template slot="header" slot-scope="scope">
          <div class="table-dropdown-header">
            <div class="cursor-pointer" @click="showSourceList = !showSourceList">
              Message source
              <i v-show="showSourceList" class="el-icon-arrow-down"></i>
              <i v-show="!showSourceList" class="el-icon-arrow-up"></i>
            </div>
            <ul class="table-dropdown-content" v-show="showSourceList">
              <li class="cursor-pointer"
                  :class="productLine == item.value ? 'active' : ''"
                  @click="changeSourceGetList(item.value)"
                  v-for="item in sourceList"
                  :key="item.value">{{ item.text }}
              </li>
            </ul>
          </div>
        </template>
        <template slot-scope="scope">
          <div v-for="item in sourceList">
            <span v-if="item.chineseTxt == scope.row.productLine">{{item.text}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="210">
        <template slot="header" slot-scope="scope">
          Time <span class="sort-icon"></span>
        </template>
        <template slot-scope="scope">
          {{scope.row.createTime | time}}
        </template>
      </el-table-column>
      <el-table-column
              prop="antiCreeping"
              label="Action"
              width="180">
        <template slot-scope="scope">
          <el-button
                  type="text"
                  @click="viewContent(scope.row)">View</el-button>
        </template>
      </el-table-column>

    </el-table>

    <el-dialog
            custom-class="realEstate"
            title="提示"
            :visible.sync="centerDialogVisible">
      <p>您即将进入地产系统，为确保功能正常使用，请使用IE10及以上版本浏览器，并设置兼容性</p>
      <!--<p><a href="javascript:;" @click="ieDown">IE10兼容性设置方法.docx</a></p>-->
      <p><a href="https://fosun-upload-prod.oss-cn-hangzhou.aliyuncs.com/%E5%A4%8D%E6%98%9F%E5%9C%B0%E4%BA%A7%E7%B1%BB%E9%A1%B9%E7%9B%AEIE%E6%B5%8F%E8%A7%88%E5%99%A8%E5%85%BC%E5%AE%B9%E6%80%A7%E8%AE%BE%E7%BD%AE.docx">IE10兼容性设置方法.docx</a></p>
      <span slot="footer" class="dialog-footer clearfix">
        <el-checkbox v-model="noMorePrompts">今天不再提示</el-checkbox>
        <el-button type="primary" @click="centerDialogFn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import Cookies from 'js-cookie'
  export default {
    name: "index",
    props: {
      tableData: {
        type: Array,
        default: []
      },
      productLine: {
        type: String,
        default: ''
      },
      activeName: {
        type: String,
        default: '0'
      }
    },
    data () {
      return {
        showSourceList: false,
        sourceList: [
          {text: 'All', value: ''},
          {text: 'Bidding System', value: 'RECRUITING_PLATFORM', chineseTxt: '采招系统' },
          {text: 'Centralized Procurement Shopping Mall', value: 'JICHAI_MALL', chineseTxt: '集采商城' },
          {text: 'Order Mgt. System', value: 'Order_Coordination', chineseTxt: '订单协同' },
          {text: 'Base Mgt. System', value: 'Basic_Application', chineseTxt: "基础应用"},
          {text: 'Supplier Mgt. System', value: 'SRM', chineseTxt:"供应商管理"},
          {text: 'Contract Mgt. System', value: 'CONTRACT', chineseTxt:"合同管理"},
          {text: 'Requirement Mgt. System', value: 'REQUIREMENT', chineseTxt:"需求管理"}
        ],
        refSysId: '',
        detailInfo: {},
        centerDialogVisible: false,
        noMorePrompts: false
      }
    },
    computed: mapState([
      'KP'
    ]),
    created () {
      if(this.getToken('isLogin') == 100){
        let loginInfo = this.getDAesString(this.getToken('loginInfo'),this.KP.key,this.KP.iv)
        this.refSysId = loginInfo.refSysId
      }
    },
    methods: {
      changeSourceGetList (value, b) {
        this.$emit('changeSourceGetList', value)
        this.showSourceList = false
      },

      viewContent (item) {
        /*
        * 1. 判断是否提示跳转地产项目
        * */
        this.detailInfo = item
        if(item.productLine == "-" && this.getCookie('TODAY_NO_MORE_REMINDER') == 0){
          this.centerDialogVisible = true;
        } else {
          this.openViewContent(item)
        }
      },
      /*
       * 1. 未读消息调用已读接口跳转对应的内容页
       * 2. 根据返回消息url类型对应跳转方式(站内或站外)
       *    - 是否是供应商管理
       *    - 是否是ep.fosunproperty.com
       * */
      openViewContent (item) {
        if (this.activeName == '2') {
          this.markRead(item.id, item.content)
        } else {
          if(item.url.slice(0,4) == 'http'){
            if(item.productLine == '供应商管理') {
              window.location.href = item.url + item.isFinish + "&Id=" + item.id;
            } else {
              if(item.url.indexOf("ep.fosunproperty.com") > 0) {
                let userSsoToken = Cookies.get("user_sso_token");
                let guid = this.getUrlKey('guid', "?" +  item.url.split("?")[1])
                let openUrl = "https://ep.fosunproperty.com:8888/"+"Interface/YiLianAction.aspx?action=centerPage&token="+userSsoToken+"&pguid="+ this.refSysId+"&language=en_CN";
                window.location.href= openUrl;
              } else if(item.url.indexOf("?")>0){
                window.location.href = item.url + "&todoId=" + item.id;
              } else{
                window.location.href = item.url + "?todoId=" + item.id;
              }
            }
          } else {
            this.$router.push({path:'/messageNotificationDetails',query:{ noticeId: item.id }})
          }
        }
      },

      // 修改未读状态
      markRead (id, messageUrl) {
        this.$axios.post('/onelink.mdata.main.api/message/markRead', {
          id:id
        }).then((res) => {
          this.data = res.data;
          if(messageUrl.slice(0,4) == 'http'){
            window.location.href = messageUrl;
          }else{
            this.$router.push({path:'/messageNotificationDetails',query:{noticeId:id}})
          }
        }).catch((err) => {
          console.log(err)
        })
      },

      // 进入地产系统
      centerDialogFn(){
        this.centerDialogVisible = false;
        if(this.noMorePrompts) {
          this.$axios.post('/onelink.mdata.main.api/web/todayNoMoreRemainder', {
          }).then((res) => {
            if(res.data.code == 0){
              this.openViewContent(this.detailInfo)
            }
          }).catch((err) => {
            console.log(err)
          })
        } else {
          this.openViewContent(this.detailInfo)
        }

      }
    }
  }
</script>

<style lang="stylus">

  .message-table-en {
    overflow: visible !important;
    .el-table__header-wrapper{
      overflow: visible;
    }
    thead th{
      padding: 4px 0;
      background: #e8ecf2;
      color: #a8acb2;
      overflow: visible;
      div{
        overflow: visible !important;
      }
    }
    tbody td {
      padding 4px 0;
    }
    .sort-icon{
      position: relative;
      top: 3px;
      width: 16px;
      height: 16px;
      display: inline-block;
      background: url('https://fosun-portal-oss.oss-cn-hangzhou.aliyuncs.com/onelink.mdata.main.ui.pro/sort_icon.png') no-repeat 50%;
      background-size: contain;
    }
    .table-dropdown-header{
      padding-left: 0;
      > div{
        padding-left: 0;
      }
    }
    .table-dropdown-content{
      position: absolute;
      top: 44px;
      left: 0;
      z-index: 1;
      box-shadow: 0 0 16px 0 rgba(0,0,0,.1);
      color: #303133;
      padding: 8px 4px;
      border-radius: 4px;
      background-color: #fff
      &:after{
        position: absolute;
        content: '';
        top: -6px;
        left: 50%;
        transform: translateX(-50%);
        border: 6px solid transparent;
        border-top-width: 0;
        border-bottom-color: #fff;
      }
      li{
        height: 40px
        line-height: 40px;
        min-width: 108px;
        text-align: center;
        &.active{
          background-color: #e8ecf2;
          color: #303133;
        }
        &:hover{
          /*background-color: #e8ecf2;*/
          /*color: #303133;*/
          color: #409eff;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/messageTableEn/index.vue